<script setup lang="ts">
/**
 * A prompt image: an object path exchanged for a signed link, a URL passed through. An absent or
 * unsignable image renders a labelled placeholder, never a broken `<img>`.
 */
import type { ImageBlock } from '../../../../../model/assessments/interfaces'

import { AppText } from '@shared/ui/typography'

import { useAssignmentMediaSrc } from '../../../../../model/assignments/media-asset.hook'

defineOptions({
  name: 'ExercisePromptImage',
})

const props = defineProps<{
  block: ImageBlock
}>()

const {
  refSrc,
  refIsResolving,
  refError,
} = useAssignmentMediaSrc(() => props.block.asset?.url)
</script>

<template>
  <img
    v-if="refSrc"
    class="exercise-prompt-image"
    :src="refSrc"
    :alt="block.alt ?? ''"
  >
  <AppText
    v-else
    name="body2"
    color="slate-500"
    class="exercise-prompt-image__placeholder"
  >
    <template v-if="!block.asset?.url">
      Image — none uploaded yet.
    </template>
    <template v-else-if="refIsResolving">
      Image — loading…
    </template>
    <template v-else>
      Image — {{ refError ?? 'could not be loaded' }}
    </template>
  </AppText>
</template>

<style scoped lang="scss" src="./ExercisePromptImage.scss" />
